import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ShieldCheck, SignOut, List } from "@phosphor-icons/react";
import { useState } from "react";

export default function Header({ minimal = false }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="border-b border-[#e4e4e7] bg-white sticky top-0 z-40" data-testid="site-header">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
          <ShieldCheck size={26} weight="duotone" color="#002FA7" />
          <span className="font-heading font-extrabold tracking-tight text-lg">
            PriceGuard <span className="text-[#002FA7]">NZ</span>
          </span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {!minimal && !user && (
            <>
              <a href="#how" className="text-sm font-medium text-[#52525b] hover:text-black">How it works</a>
              <Link to="/retailers" className="text-sm font-medium text-[#52525b] hover:text-black" data-testid="nav-retailers">Retailers</Link>
              <Link to="/about" className="text-sm font-medium text-[#52525b] hover:text-black" data-testid="nav-about">About</Link>
              <Link to="/faq" className="text-sm font-medium text-[#52525b] hover:text-black" data-testid="nav-faq">FAQ</Link>
              <Link to="/pricing" className="text-sm font-medium text-[#52525b] hover:text-black" data-testid="nav-pricing">Pricing</Link>
            </>
          )}
          {user ? (
            <div className="flex items-center gap-4">
              <Link to="/dashboard" className="text-sm font-semibold inline-flex items-center gap-1.5" data-testid="nav-dashboard">
                Dashboard
              </Link>
              <Link to="/faq" className="text-sm font-medium text-[#52525b] hover:text-black" data-testid="nav-faq-auth">
                FAQ
              </Link>
              <Link to="/pricing" className="text-sm font-medium text-[#52525b] hover:text-black" data-testid="nav-pricing-auth">
                Pricing
              </Link>
              {user.plan === "pro" ? (
                <span className="inline-flex items-center gap-1 bg-[#0a0a0a] text-white text-[10px] font-bold tracking-widest uppercase px-2 py-1" data-testid="nav-pro-badge">
                  Pro
                </span>
              ) : (
                <Link to="/pricing" className="text-sm font-semibold text-[#002FA7] hover:text-[#00207A]" data-testid="nav-upgrade">
                  Upgrade
                </Link>
              )}
              <span className="pg-overline" data-testid="nav-user-email">{user.email}</span>
              <button onClick={handleLogout} className="text-sm font-semibold flex items-center gap-1.5 hover:text-[#FF3B30]" data-testid="logout-btn">
                <SignOut size={16} /> Logout
              </button>
            </div>
          ) : (
            <div className="flex items-center gap-3">
              <Link to="/login" className="text-sm font-semibold" data-testid="nav-login">Login</Link>
              <Link to="/signup" className="bg-[#002FA7] text-white font-bold text-sm px-5 py-2.5 hover:bg-[#00207A]" data-testid="nav-signup">
                Start tracking
              </Link>
            </div>
          )}
        </nav>
        <button className="md:hidden" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
          <List size={24} />
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-[#e4e4e7] bg-white px-6 py-4 flex flex-col gap-3">
          {user ? (
            <>
              <Link to="/dashboard" className="text-sm font-semibold">Dashboard</Link>
              <Link to="/faq" className="text-sm font-semibold text-[#52525b]" data-testid="nav-faq-auth-mobile">FAQ</Link>
              <Link to="/pricing" className="text-sm font-semibold text-[#52525b]" data-testid="nav-pricing-auth-mobile">Pricing</Link>
              {user.plan === "pro" ? (
                <span className="text-sm font-semibold inline-flex items-center gap-2" data-testid="nav-pro-badge-mobile">
                  <span className="bg-[#0a0a0a] text-white text-[10px] font-bold tracking-widest uppercase px-2 py-1">Pro</span>
                  Your account
                </span>
              ) : (
                <Link to="/pricing" className="text-sm font-semibold text-[#002FA7]" data-testid="nav-upgrade-mobile">Upgrade to Pro</Link>
              )}
              <button onClick={handleLogout} className="text-sm font-semibold text-left">Logout</button>
            </>
          ) : (
            <>
              <Link to="/about" className="text-sm font-semibold text-[#52525b]" data-testid="nav-about-mobile">About</Link>
              <Link to="/retailers" className="text-sm font-semibold text-[#52525b]" data-testid="nav-retailers-mobile">Retailers</Link>
              <Link to="/faq" className="text-sm font-semibold text-[#52525b]" data-testid="nav-faq-mobile">FAQ</Link>
              <Link to="/pricing" className="text-sm font-semibold text-[#52525b]" data-testid="nav-pricing-mobile">Pricing</Link>
              <Link to="/login" className="text-sm font-semibold">Login</Link>
              <Link to="/signup" className="text-sm font-semibold text-[#002FA7]">Start tracking</Link>
            </>
          )}
        </div>
      )}
    </header>
  );
}
